export function WalletConnectIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
    >
      <path
        d="M102.36 161.86c84.74-82.96 222.15-82.96 306.89 0l10.19 9.98c4.24 4.15 4.24 10.89 0 15.04l-34.83 34.12c-2.12 2.08-5.55 2.08-7.67 0l-14.03-13.74c-59.2-57.99-155.11-57.99-214.31 0l-15.03 14.72c-2.12 2.08-5.55 2.08-7.67 0l-34.83-34.12c-4.24-4.15-4.24-10.89 0-15.04l11.29-11.06zm379.14 70.98l31.03 30.4c4.24 4.15 4.24 10.89 0 15.04L372.34 413.61c-4.24 4.15-11.11 4.15-15.35 0L255.94 315.2c-1.06-1.04-2.77-1.04-3.83 0l-101.05 98.97c-4.24 4.15-11.11 4.15-15.35 0L5.47 278.28c-4.24-4.15-4.24-10.89 0-15.04l31.03-30.4c4.24-4.15 11.11-4.15 15.35 0l101.05 98.97c1.06 1.04 2.77 1.04 3.83 0L257.78 233.8c4.24-4.15 11.11-4.15 15.35 0l101.05 98.97c1.06 1.04 2.77 1.04 3.83 0l101.05-98.97c4.24-4.15 11.11-4.15 15.35 0h-.01z"
        fill="#3B99FC"
      />
    </svg>
  );
}
